import React from "react";
import { message, notification } from "antd";

// Brand-consistent toasts for the whole app. `message` = compact single feedback;
// `notification` = rich card for multiple issues. The look is applied globally in
// styles/notify.css, so existing message.*/notification.* calls inherit it too.

// Called once at startup (from index.js) for consistent placement/timing.
export const configureNotifications = () => {
  message.config({ top: 72, duration: 3, maxCount: 3 });
  notification.config({ placement: "topRight", duration: 4.5 });
};

export const showError = (text) => message.error(text);
export const showSuccess = (text) => message.success(text);
export const showWarning = (text) => message.warning(text);
export const showInfo = (text) => message.info(text);

// One or many specific problems. 0/1 → compact toast; many → a titled card with
// a clear bulleted list of exactly what to fix.
export const showIssues = (title, items = []) => {
  const list = (Array.isArray(items) ? items : [items]).filter(Boolean);
  if (list.length <= 1) {
    message.error(list[0] || title);
    return;
  }
  notification.error({
    message: title,
    className: "arc-notify arc-notify-error",
    description: (
      <ul className="arc-notify-list">
        {list.map((it, i) => (
          <li key={i}>{it}</li>
        ))}
      </ul>
    ),
  });
};

// A branded notification card (title + description). Replaces the per-file
// `notification.useNotification()` + `openNotificationWithIcon` boilerplate.
// `description` may be a string or a React node (e.g. a job link).
export const showNotice = (type, title, description) => {
  const fn = notification[type] || notification.info;
  fn({
    message: title,
    description,
    className: `arc-notify arc-notify-${type}`,
  });
};

// Consistent extraction of a backend error message for ad-hoc .catch sites.
export const showApiError = (err, fallback = "Something went wrong.") =>
  message.error(err?.response?.data?.message || err?.message || fallback);
